import { Loader2Icon } from "lucide-react";

import type { ConnectionView, ConnectionsCapabilities } from "../../state/connections";
import { Button } from "../ui/button";
import { getPluginAccountState } from "./pluginContent";
import type { PluginAccountActions } from "./usePluginConnections";

/** The same actions and capability checks on every plugin surface. */
export function PluginAccountButtons({
  connection,
  capabilities,
  actions,
}: {
  readonly connection: ConnectionView;
  readonly capabilities: ConnectionsCapabilities;
  readonly actions: PluginAccountActions;
}) {
  const state = getPluginAccountState(connection, capabilities);
  const busy = actions.isBusy(connection.id);
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-2">
      {state.pending ? (
        <span role="status" className="text-xs text-muted-foreground">
          {state.label}
        </span>
      ) : state.canConnect ? (
        <Button
          size="sm"
          disabled={busy}
          onClick={() =>
            state.needsReconnect
              ? actions.onReconnect(connection.id)
              : actions.onConnect(connection.id)
          }
        >
          {busy ? <Loader2Icon className="size-4 animate-spin" /> : null}
          Connect
        </Button>
      ) : !state.connected ? (
        <span className="text-xs text-muted-foreground">Connection unavailable</span>
      ) : null}
      {state.canDisconnect ? (
        <Button
          size="sm"
          variant="outline"
          disabled={busy}
          onClick={() => actions.onDisconnect(connection.id)}
        >
          {busy ? <Loader2Icon className="size-4 animate-spin" /> : null}
          Disconnect
        </Button>
      ) : null}
    </div>
  );
}
